import React from 'react'
import OldStudents from './OldStudents'
import { useNavigate } from 'react-router-dom'

const OldStudentFnCom = () => {
    const navigate = useNavigate()
    return (
        <>
            <OldStudents navigate={navigate} />
        </>
    )
}

export default OldStudentFnCom